import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDashboard from './dashboard.reducer';

export const selectDashboardState = createFeatureSelector<fromDashboard.State>(
  fromDashboard.dashboardFeatureKey
);

export const selectDashboards = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.dashboards
);

export const selectSelectedDashboard = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) =>
    state.dashboards.find((db) => db.id == state.selectedDashboardId) || null
  // use == to avoid mistakes when compairing ids from params (always string) with numeric ids
);

export const selectSelectedDashboardId = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.selectedDashboardId
);

export const selectDateRangeQuery = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.queryDateRange
);

export const selectGlobalFilterValues = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.globalFilterValues
);

export const selectBlockActionExecutions = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.blockActionExecutions
);

export const selectBlockActionExecutionsLoading = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.blockActionExecutionsLoading
);

export const selectHttpResult = createSelector(
  selectDashboardState,
  (state: fromDashboard.State) => state.httpResult
);
